module.exports = __webpack_public_path__ + "static/img/building-op.1a046ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/building-op.png
// module id = pzQH
// module chunks = 1